import * as AppConstants from "AppConstants";

export const getAuthenticationUrl = () => {
    const url = AppConstants.POST_LOGIN_ENDPOINT;
    return url;
}